import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=1fd3868d&scoped=true&"
import script from "./import-file.vue?vue&type=script&lang=js&"
export * from "./import-file.vue?vue&type=script&lang=js&"
import style0 from "./import-file.vue?vue&type=style&index=0&id=1fd3868d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3868d",
  null
  
)

export default component.exports